module.exports = __webpack_public_path__ + "static/media/banner_420x230_1.f61e51a1.jpg";